import styles from "./servicos.module.css";
import ServicosCover from "../../components/ServicosComponents/ServicosCover/servicos-cover";
import ServicoCard from "../../components/ServicosComponents/ServicoCard/servico-card";

interface IProps {
  onHandlePages: any;
}

const ServicosPage = ({ onHandlePages }: IProps) => {
  return (
    <main className={styles.servicos_main}>
      <section className={styles.servicos_section}>
        <ServicosCover />
        <div className={styles.servicos_list}>
          <ul className={styles.servicos_cards_div}>
            <ServicoCard
              title="Strategic Planning"
              description="A TruEvidence nasceu com o objetivo de dar suporte principalmente à
        indústria farmacêutica e instituições de saúde a criar e fazer uso das
        evidências científicas..."
              onHandlePages={onHandlePages}
              url={"/produtos/strategic-planning"}
            />
            <ServicoCard
              title="RWE Analytics"
              description="Realizamos consultorias em análises de dados de mundo real (RWD) de
          múltiplas fontes, produzindo resultados compilados em deck de slides e planilhas..."
              onHandlePages={onHandlePages}
              url={"/produtos/rwe-analytics"}
            />
            <ServicoCard
              title="Trainings & Workshops"
              description="Ofertamos treinamentos e capacitações em temas relacionados à
          epidemiologia, desenhos de estudos, dados de mundo real (RWD) e evidência
          de mundo real (RWE)...."
              onHandlePages={onHandlePages}
              url={"/produtos/trainings-workshops"}
            />
          </ul>
          <ul className={styles.servicos_cards_div}>
            <ServicoCard
              title="Scientific Writing & Communication"
              description="Produzimos documentos de escrita científica relacionada à análise de 
              dados de mundo real (RWD) em múltiplas formas..."
              onHandlePages={onHandlePages}
              url={"/produtos/scientific-writing-communication"}
            />
            <ServicoCard
              title="Masterclasses"
              description="Ofertamos masterclasses em temas relacionados à epidemiologia, desenhos
              de estudos, dados de mundo real (RWD) e evidência de mundo real (RWE)..."
              onHandlePages={onHandlePages}
              url={"/produtos/masterclasses"}
            />
          </ul>
        </div>

        <div className={styles.servicos_listMobile}>
          <ul className={styles.servicos_cards_div}>
            <ServicoCard
              title="Strategic Planning"
              description="A TruEvidence nasceu com o objetivo de dar suporte principalmente à
        indústria farmacêutica e instituições de saúde a criar e fazer uso das
        evidências científicas..."
              onHandlePages={onHandlePages}
              url={"/produtos/strategic-planning"}
            />
            <ServicoCard
              title="RWE Analytics"
              description="Realizamos consultorias em análises de dados de mundo real (RWD) de
          múltiplas fontes, produzindo resultados compilados em deck de slides e planilhas..."
              onHandlePages={onHandlePages}
              url={"/produtos/rwe-analytics"}
            />
            <ServicoCard
              title="Trainings & Workshops"
              description="Ofertamos treinamentos e capacitações em temas relacionados à
          epidemiologia, desenhos de estudos, dados de mundo real (RWD) e evidência
          de mundo real (RWE)...."
              onHandlePages={onHandlePages}
              url={"/produtos/trainings-workshops"}
            />
            <ServicoCard
              title="Scientific Writing & Communication"
              description="Produzimos documentos de escrita científica relacionada à análise de 
              dados de mundo real (RWD) em múltiplas formas..."
              onHandlePages={onHandlePages}
              url={"/produtos/scientific-writing-communication"}
            />
            <ServicoCard
              title="Masterclasses"
              description="Ofertamos masterclasses em temas relacionados à epidemiologia, desenhos
              de estudos, dados de mundo real (RWD) e evidência de mundo real (RWE)..."
              onHandlePages={onHandlePages}
              url={"/produtos/masterclasses"}
            />
          </ul>
        </div>
      </section>
    </main>
  );
};

export default ServicosPage;
